import axios from 'axios';

export const getUserAbsences = async (upn) => {
  try {
    const response = await axios.post('https://prod-176.westeurope.logic.azure.com:443/workflows/f3638076343143e0ae19a82d6e84ede6/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=tVjnL5br74cp9Ijc0SznAnEQL4Uf4MisvDnN2bKdBnU', {
      upn 
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des informations utilisateur:', error);
    throw error;
  }
}; 